module.exports = __webpack_public_path__ + "static/media/BI.7fc05eb8.svg";